import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { AssessmentSessionUpdateInput } from '../generated/globalTypes';
import { updateAssessmentSessionMutation, updateAssessmentSessionMutationVariables } from '../generated/updateAssessmentSessionMutation';
import { assessmentSessionFieldsFragment } from '../models/AssessmentSession';

/**
 * Get a callback to update a AssessmentSession in the store.
 */
export function useUpdateAssessmentSessionCallback(): [(id: string, model: AssessmentSessionUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateAssessmentSessionMutation, updateAssessmentSessionMutationVariables>(
        gql`
            mutation updateAssessmentSessionMutation ($model: AssessmentSessionUpdateInput!) {
                updateAssessmentSession(model: $model) {
                    ...assessmentSessionFields
                }
            }

            ${assessmentSessionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: AssessmentSessionUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
